import api from '../utils/api'

// Action Types
export const CV_JOBS_FETCH_STORAGE_STATUS = 'CV_JOBS_FETCH_STORAGE_STATUS'
export const CV_JOBS_FETCH_STORAGE_STATUS_SUCCESS = 'CV_JOBS_FETCH_STORAGE_STATUS_SUCCESS'
export const CV_JOBS_FETCH_STORAGE_STATUS_ERROR = 'CV_JOBS_FETCH_STORAGE_STATUS_ERROR'

export const CV_JOBS_FETCH_PREVIEW = 'CV_JOBS_FETCH_PREVIEW'
export const CV_JOBS_FETCH_PREVIEW_SUCCESS = 'CV_JOBS_FETCH_PREVIEW_SUCCESS'
export const CV_JOBS_FETCH_PREVIEW_ERROR = 'CV_JOBS_FETCH_PREVIEW_ERROR'

export const CV_JOBS_START_BULK = 'CV_JOBS_START_BULK'
export const CV_JOBS_START_BULK_SUCCESS = 'CV_JOBS_START_BULK_SUCCESS'
export const CV_JOBS_START_BULK_ERROR = 'CV_JOBS_START_BULK_ERROR'

export const CV_JOBS_UPDATE_PROGRESS = 'CV_JOBS_UPDATE_PROGRESS'
export const CV_JOBS_COMPLETE = 'CV_JOBS_COMPLETE'
export const CV_JOBS_RESET = 'CV_JOBS_RESET'

// Action Creators
export const fetchStorageStatus = () => async (dispatch) => {
  dispatch({ type: CV_JOBS_FETCH_STORAGE_STATUS })
  try {
    const result = await api.getCvStorageStatus()
    dispatch({ type: CV_JOBS_FETCH_STORAGE_STATUS_SUCCESS, payload: result })
  } catch (error) {
    dispatch({ type: CV_JOBS_FETCH_STORAGE_STATUS_ERROR, payload: error.message })
  }
}

export const fetchBulkPreview = (days) => async (dispatch) => {
  dispatch({ type: CV_JOBS_FETCH_PREVIEW })
  try {
    const result = await api.getBulkCvPreview(days)
    dispatch({ type: CV_JOBS_FETCH_PREVIEW_SUCCESS, payload: result })
  } catch (error) {
    dispatch({ type: CV_JOBS_FETCH_PREVIEW_ERROR, payload: error.message })
  }
}

export const startBulkRegenerate = (days) => async (dispatch) => {
  dispatch({ type: CV_JOBS_START_BULK })
  try {
    const result = await api.startBulkCvRegenerate(days)
    dispatch({ type: CV_JOBS_START_BULK_SUCCESS, payload: result })
    
    // Subscribe to progress updates
    api.subscribeToCvJobProgress(
      result.jobId,
      (progress) => dispatch({ type: CV_JOBS_UPDATE_PROGRESS, payload: progress }),
      (error) => console.error('Progress error:', error),
      (finalStatus) => dispatch({ type: CV_JOBS_COMPLETE, payload: finalStatus })
    )
  } catch (error) {
    dispatch({ type: CV_JOBS_START_BULK_ERROR, payload: error.message })
  }
}

export const resetCvJobs = () => ({ type: CV_JOBS_RESET })
